import { DefaultDatePickerInput } from "../../../../../../common/components/default_date_picker_input";
import { useMemo } from "react";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { MaquinaEquipDropdown } from "../../../../domain/models/maquina_equip_dropdown";

import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import DefaultInput from "../../../../../../common/components/default_input";

type Props = {
  maquinaEquip: number[] | null;
  maquinaEquipDropDown: MaquinaEquipDropdown[];
  dataEntradaDe: Date | null;
  dataEntradaAte: Date | null;
  codigo: string | null,
  onMaquinaEquipChange: (maquinaEquip: number[] | null) => void;
  handleDataEntradaRangeChange: (v: Date | null, x: Date | null) => void;
  handleCodigo: (v: string ) => void,
  onClear: () => void;
};

export const Header = ({
  maquinaEquip,
  maquinaEquipDropDown,dataEntradaAte, dataEntradaDe, codigo,handleDataEntradaRangeChange, handleCodigo,
  onMaquinaEquipChange,
  onClear,
}: Props) => {

  const selectedMaquinaEquip = useMemo(() => {
    if (!maquinaEquip || maquinaEquip.length === 0) return null;
    return maquinaEquipDropDown.filter((x) => maquinaEquip.includes(x.idMaquinaEquip));
  }, [maquinaEquip, maquinaEquipDropDown]);

  return (
    <CascateList title="Pesquisar" defaultOpen={true}>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 lg:grid-cols-2 grid-flow-row-dense">
          <DefaultDateRangePickerInput
            label='Data de Entrada'
            dataDe={dataEntradaDe ?? null}
            dataAte={dataEntradaAte ?? null}
            onChange={async (start, end) => {
              handleDataEntradaRangeChange(start, end)
            }}
          />
          <DefaultMultiAutocomplete
            label="Máquina/Equipamento"
            options={maquinaEquipDropDown}
            getOptionKey={(x) => x.idMaquinaEquip}
            getOptionLabel={(x) => x.descricao}
            value={selectedMaquinaEquip}
            onChange={x => onMaquinaEquipChange(x !== null ? x.map((y) => y.idMaquinaEquip) : null)}
          />
        </div>
        <div className="w-full">
        </div>
        <div className="w-full">
          <DefaultInput
            label="Codigo"
            name="search_by_name"
            value={typeof codigo === 'string' ? codigo : ''}
            onChangeValue={handleCodigo}
          />
        </div>

        <div className="w-full flex flex-col items-end">
          <div className="w-[7.5rem]">
            <PrimaryButton buttonColor="yellow" onClick={onClear}>
              Limpar
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList >
  );
};
